/* Package JSON Import will be here */
import React from "react";
import { getTranslate } from "react-localize-redux";
import { useSelector } from "react-redux";
/* Package JSON Import will be here */

/* Project Import will be here */
import { getCultureNumberFormat } from "utilities/utils";
/* Project Import will be here */

const DiscountDetails = (props) => {
    const { translate } = useSelector((state) => ({
        translate: getTranslate(state.locale)
    }));

    return (
        <React.Fragment>
            <p className="font--16"><strong>{props.selectedDisc.Desc}</strong></p>
            <p>{translate("discount.discountType")}: {props.selectedDisc.IsPercentage ? translate("discount.percentageDiscount") : translate("discount.valueDiscount")}</p>
            <p>{translate("discount.discountValue")}: {props.selectedDisc.IsPercentage ? props.selectedDisc.Value + "%" : getCultureNumberFormat(props.selectedDisc.Value, true)}</p>
        </React.Fragment>

    );
};

export default DiscountDetails;